import { useAttachmentObjectUrl } from './useAttachmentObjectUrl';
import { cn } from '@/lib/utils';

/**
 * Renders an attachment image fetched with auth (the download endpoint needs a
 * bearer token, so a plain <img src> won't work). Shows a pulse placeholder
 * until the blob resolves.
 */
export function AuthImage({
  id,
  alt,
  className,
  onClick
}: {
  id: string;
  alt: string;
  className?: string;
  onClick?: () => void;
}) {
  const src = useAttachmentObjectUrl(id);
  if (!src) return <div className={cn('animate-pulse bg-muted rounded', className)} />;
  return <img src={src} alt={alt} className={className} onClick={onClick} />;
}
